import React, { useState, useEffect, useMemo } from "react";
import { useExam } from "../../context/ExamContext";
import parse from "html-react-parser";
import stringQuestionIntervalToArray from "../../utils/stringQuestionIntervalToArray";
import useScrollToActiveQuestion from "../../hooks/useScrollToActiveQuestion";

function Matching({ questionSet }) {
  const { questionInterval, answerOptions, questions, heading } = questionSet;

  const { updateAnswer, answers } = useExam();
  const [inputs, setInputs] = useState({});
  const { activeQuestion, setActiveQuestion } = useExam();
  const answerOptionsKeys = answerOptions.map(opt => opt.key);
  const allSetQuestionNumbers = useMemo(
    () => stringQuestionIntervalToArray(questionInterval),
    [questionInterval]
  );

  const scrollRef = useScrollToActiveQuestion(allSetQuestionNumbers);


  useEffect(() => {
    const initial = {};
    answers
      .filter(ans => allSetQuestionNumbers.includes(ans.questionNumber))
      .forEach(ans => {
        initial[ans.questionNumber] = ans.answer || "";
      });
    setInputs(initial);
  }, [answers, allSetQuestionNumbers]);

  const handleChange = (e, idx) => {
    const label = e.target.value;
    const questionNumber = allSetQuestionNumbers[idx];

    setInputs(prev => ({ ...prev, [questionNumber]: label }));

    updateAnswer({
      questionNumber,
      answer: label,
    });
  };
  // useEffect(() => {
  //   if (!set.commonQuestion) return;

  //   const newInputs = answers.reduce((acc, curr) => {
  //     acc[curr.questionNumber] = curr.answer || "";
  //     return acc;
  //   }, {});

  //   setInputs(newInputs);
  // }, [set.commonQuestion, answers]);

  // useEffect(() => {
  //   const nextInput = document.querySelector(
  //     `[data-question='${+activeQuestion}']`
  //   );
  //   if (nextInput) nextInput.focus();

  // }, [activeQuestion])



  // const handleInputChange = (questionNumber, value) => {
  //   // setActiveQuestion(Number(questionNumber) + 1);

  //   setInputs((prev) => ({
  //     ...prev,
  //     [questionNumber]: value,
  //   }));
  // };

  // const handleBlurOrSubmit = (questionNumber) => {
  //   if (
  //     inputs[questionNumber] !==
  //     answers.find((a) => a.questionNumber == questionNumber)?.answer
  //   ) {
  //     updateAnswer({
  //       questionNumber: +questionNumber,
  //       answer: inputs[questionNumber] || "",
  //     });
  //   }
  // };

  // const handleKeyDown = (e, questionNumber) => {
  //   if (e.key === "Enter" || e.key === "Tab") {
  //     e.preventDefault();
  //     handleBlurOrSubmit(questionNumber);
  //     const nextInput = document.querySelector(
  //       `[data-question='${+questionNumber + 1}']`
  //     );
  //     if (nextInput) nextInput.focus();
  //   }
  // };

  // const handleClick = (questionNumber) => {
  //   setActiveQuestion(questionNumber)
  // };


  return (
    <div
      ref={scrollRef}
      className="input-completion"
      style={{ fontSize: '1rem', color: 'black' }}
    >
      <div dangerouslySetInnerHTML={{ __html: heading }} />
      <div className="mt-2 mb-6 answerOptions">
        {answerOptions.map(element => (
          <div key={element.key}>
            <strong className="mr-1">
              {element.key}.
            </strong>
            <span>{element.answer}</span>
          </div>
        ))}
      </div>

      {questions.map((opt, idx) => {

        const qn = allSetQuestionNumbers[idx];
        const current = inputs[qn] || "";
        const choices = ["", ...answerOptionsKeys];

        // const takenByOthers = Object.entries(inputs)
        //   .filter(([otherQn, _]) => otherQn !== String(qn))
        //   .map(([_, lab]) => lab);
        // const choices = [""].concat(
        //   LABELS.filter(l => !takenByOthers.includes(l) || l === current)
        // );

        return (
          <div
            key={qn}
            style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
          >
            <div className="question-title">
              <strong
                style={{ marginLeft: "-6px" }}
                className={`inline-block question mr-[12px]  px-1 ${activeQuestion === opt.questionNumber
                  ? 'questionBorderActive'
                  : 'questionBorder'
                  }`}
              >
                {opt.questionNumber}
              </strong>
              {opt.question || "No question provided"}
            </div>
            <div
              className={
                activeQuestion === qn
                  ? 'questionBorderActive'
                  : 'questionBorder'
              }
              style={{ marginLeft: 10 }}
            >
              <select
                value={current}
                onChange={e => handleChange(e, idx)}
                style={{
                  width: 85,
                  height: 32,
                  paddingLeft: 8,
                  backgroundColor: "var(--background-color)",
                  color: "var(--text-color)"
                }}
              >
                {choices.map(l => (
                  <option key={l} value={l}>
                    {l}
                  </option>
                ))}
              </select>
            </div>
          </div>
        );
      })}
    </div>
  )
}


export default Matching;
